export default __webpack_public_path__ + "static/飞书20210915-180123-en-ab9f658c5939e9124a2dbe7b06d80d50.png";